<span *ngIf="outcome" class="user-text" [innerHTML]="innerHtml"></span>
